import { withSentry } from '../../modules/sentry';
import $dom from 'cash-dom';
import machineSelector from '../../modules/machine_selector';

$dom(document).ready(
  withSentry(() => {
    console.log('initializing machine_comparison scripts');

    machineSelector();
  })
);
